export default __webpack_public_path__ + "static/media/mastercard.5ad314e8.png";